<div class="influencer-nav-bar">
  <button class="btn btn-sm btn-outline-primary"
          [disabled]="index() <= 0 || loading() || total() === 0"
          (click)="previous.emit()">
    <i class="fa fa-chevron-left"></i> Previous
  </button>
  <span class="influencer-nav-info">
    @if (total() > 0) {
      @if (name()) {
      <span class="influencer-name">{{ name() }}</span>
      }
      <span class="influencer-counter">({{ index() + 1 }} / {{ total() }})</span>
    }
    @if (total() === 0) {
    <span class="influencer-counter">{{ emptyLabel() }}</span>
    }
  </span>
  <button class="btn btn-sm btn-outline-primary"
          [disabled]="index() >= total() - 1 || loading() || total() === 0"
          (click)="next.emit()">
    Next <i class="fa fa-chevron-right"></i>
  </button>
</div>
